import { render, staticRenderFns } from "./staffList.vue?vue&type=template&id=2c39ea88&scoped=true&"
import script from "./staffList.vue?vue&type=script&lang=js&"
export * from "./staffList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39ea88",
  null
  
)

export default component.exports